import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

const SidebarContext = createContext()

export const useSidebar = () => {
  return useContext(SidebarContext)
}

const isUpgradePath = (pathname = '') =>
  pathname === '/upgrade' || pathname.startsWith('/upgrade/')

export const SidebarProvider = ({ children }) => {
  const location = useLocation()
  const previousIsUpgradeRef = useRef(isUpgradePath(location.pathname))
  const [expanded, setExpanded] = useState(() => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : location.pathname
    if (isUpgradePath(currentPath)) return false

    try {
      const saved = localStorage.getItem('ls_sidebar_expanded')
      if (saved === null) return true
      return saved === 'true'
    } catch {
      return true
    }
  })

  useEffect(() => {
    const currentIsUpgrade = isUpgradePath(location.pathname)
    const previousIsUpgrade = previousIsUpgradeRef.current

    if (currentIsUpgrade) {
      setExpanded(false)
    } else if (previousIsUpgrade) {
      setExpanded(true)
    }

    previousIsUpgradeRef.current = currentIsUpgrade
  }, [location.pathname])

  useEffect(() => {
    try {
      localStorage.setItem('ls_sidebar_expanded', String(expanded))
    } catch {}
  }, [expanded])

  const sidebarState = {
    expanded,
    setExpanded
  }

  return (
    <SidebarContext.Provider value={sidebarState}>
      {children}
    </SidebarContext.Provider>
  )
}
